const RecoverPassword = () => (
    <h1>recover</h1>
);

export default RecoverPassword;
